import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07814439&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07814439",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07814439')) {
      api.createRecord('07814439', component.options)
    } else {
      api.reload('07814439', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=07814439&scoped=true&", function () {
      api.rerender('07814439', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/product/proCategory/index.vue"
export default component.exports